module.exports = __webpack_public_path__ + "static/media/gold.e84845c8.jpg";